import { Component, HostBinding, OnInit } from '@angular/core';

@Component({
  selector: 'smart-config-color',
  templateUrl: './config-color.component.html',
  styleUrls: ['./config-color.component.css']
})
export class ConfigColorComponent implements OnInit {

  test_color = {
    color_1: '#145231',
    color_2: '#856210',
    color_3: '#410025',
  }
  test_color_2 = {
    "color_01" : "#B1D136",
    "color_02" : "#901452",
    "color_03" : "#614E47",
  };

  constructor() { }

  ngOnInit(): void {
    sessionStorage.setItem('styles', JSON.stringify(this.test_color_2));
  }

  @HostBinding('style.--color-1') get color_1() { return this.test_color.color_1; }
  @HostBinding('style.--color-2') get color_2() { return this.test_color.color_2; }
  @HostBinding('style.--color-3') get color_3() { return this.test_color.color_3; }

  styles = (sessionStorage.getItem('styles')) ? JSON.parse(sessionStorage.getItem('styles')) : {}
  @HostBinding('style.--color-01') get color_01() { return this.styles.color_01; }
  @HostBinding('style.--color-02') get color_02() { return this.styles.color_02; }
  @HostBinding('style.--color-03') get color_03() { return this.styles.color_03; }
}
